/* Notify me when back in stock — Explorer PDP
   Self-contained modal (no theme xo-modal dependency) + Klaviyo legacy onsite
   Back in Stock submit. Delegated on document; binds on DOMContentLoaded. */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var KLAVIYO_REVISION = '2025-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';

  var openModal = null;   // currently open [data-nbis-modal]
  var lastFocus = null;

  function panel(root, name) {
    return root.querySelector('[data-nbis-panel="' + name + '"]');
  }

  /* ---- open / close ---- */

  function open(modal) {
    if (openModal) close(openModal);
    // portal to <body> so no ancestor stacking/overflow context can trap it
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    lastFocus = document.activeElement;
    modal.hidden = false;
    // force reflow, then flag for the CSS enter transition
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    openModal = modal;
    // move focus into the dialog (not the input — no keyboard pop / focus-ring on open)
    var dialog = modal.querySelector('[role="dialog"]') || modal;
    try { dialog.focus({ preventScroll: true }); } catch (e) { dialog.focus(); }
  }

  function close(modal) {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    openModal = null;
    var done = function () {
      modal.hidden = true;
      modal.removeEventListener('transitionend', done);
    };
    modal.addEventListener('transitionend', done);
    setTimeout(done, 400); // fallback if no transition fires
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  function trapTab(e) {
    if (!openModal || e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(
      openModal.querySelectorAll(FOCUSABLE),
      function (n) { return n.offsetParent !== null; }
    );
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---- submit ---- */

  function setLoading(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  function showError(form, errEl) {
    form.classList.add('is-invalid');
    if (errEl) errEl.hidden = false;
  }

  function clearError(form, errEl) {
    form.classList.remove('is-invalid');
    if (errEl) errEl.hidden = true;
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-nbis-form]')) return;
    e.preventDefault();

    var root = form.closest('[data-nbis]');
    if (!root) return;

    var input = form.querySelector('input[type="email"]');
    var errEl = form.querySelector('[data-nbis-error]');
    var btn = form.querySelector('[data-nbis-submit]');
    var label = form.querySelector('.nbis__submit-label');
    var email = (input && input.value || '').trim();

    if (!EMAIL_RE.test(email)) {
      showError(form, errEl);
      if (input) input.focus();
      return;
    }
    clearError(form, errEl);
    setLoading(btn, true);

    var companyId = root.getAttribute('data-nbis-key') || '';
    var variantId = root.getAttribute('data-nbis-variant') || '';
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
          }
        }
      }
    };

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('nbis subscribe failed (' + res.status + ')');
      })
      .then(function () {
        var formPanel = panel(root, 'form');
        var successPanel = panel(root, 'success');
        if (formPanel) formPanel.hidden = true;
        if (successPanel) {
          successPanel.hidden = false;
          var head = successPanel.querySelector('[data-nbis-success-head]');
          if (head) head.focus();
        }
        form.reset();
        track(root, email);
      })
      .catch(function (err) {
        if (window.console) {
          console.warn('[nbis] back-in-stock submit failed:', err && (err.message || err),
            '— if this is "Failed to fetch", a.klaviyo.com is being blocked (ad/privacy blocker or network).');
        }
        showError(form, errEl);
        var retry = form.getAttribute('data-nbis-retry');
        if (label && retry) label.textContent = retry;
      })
      .finally(function () {
        setLoading(btn, false);
      });
  }

  function onInput(e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-nbis-form] input[type="email"]')) return;
    var form = input.closest('[data-nbis-form]');
    if (form && form.classList.contains('is-invalid') && EMAIL_RE.test(input.value.trim())) {
      clearError(form, form.querySelector('[data-nbis-error]'));
    }
  }

  function track(root, email) {
    var detail = {
      productId: root.getAttribute('data-nbis-product') || '',
      colour: root.getAttribute('data-nbis-colour') || '',
      variant: root.getAttribute('data-nbis-variant') || ''
    };
    try { document.dispatchEvent(new CustomEvent('nbis:submitted', { detail: detail })); } catch (e) {}
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'notify_back_in_stock', nbis: detail });
      }
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') window.clarity('set', 'nbis', 'submitted');
    } catch (e) {}
    try {
      var learnq = window._learnq || window.klaviyo;
      if (learnq && typeof learnq.push === 'function') {
        learnq.push(['track', 'Requested Back in Stock', {
          Product: detail.productId, Colour: detail.colour
        }]);
      }
    } catch (e) {}
  }

  /* ---- delegated events ---- */

  function onClick(e) {
    var opener = e.target.closest('[data-nbis-open]');
    if (opener) {
      var id = opener.getAttribute('data-nbis-open');
      var modal = document.getElementById(id) || document.querySelector('[data-nbis-modal]');
      if (modal) { e.preventDefault(); open(modal); }
      return;
    }
    if (e.target.closest('[data-nbis-dismiss]') && openModal) {
      e.preventDefault();
      close(openModal);
    }
  }

  function onKeydown(e) {
    if (!openModal) return;
    if (e.key === 'Escape') { e.preventDefault(); close(openModal); }
    else trapTab(e);
  }

  function boot() {
    if (boot.done) return;
    boot.done = true;
    document.addEventListener('click', onClick, false);
    document.addEventListener('keydown', onKeydown, false);
    document.addEventListener('submit', onSubmit, false);
    document.addEventListener('input', onInput, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
